import { useEffect, useMemo } from "react";
import style from "./index.module.less";
import FontSetBox from "@/component/fontSetBox";
import { enhancedSafeChainFind } from "../../../../utils";
import { processOssImage } from "@/utils/image";
interface props {
  list: Array<any>;
  moduleJsonData: any; //样式
  isPeoModel: boolean; // 判断是 个人还是组队模式
}
const App = (props: props) => {
  const { list, isPeoModel, moduleJsonData } = props;

  // 创建排名图片的useMemo
  const firstImg = useMemo(() => {
    const visualResult = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("bgSetting")
      ?.content("rankFirst")?.val?.val;
    const rankResult = enhancedSafeChainFind(moduleJsonData.rankImg)?.rankData(
      "rankFirst",
    )?.val?.val;
    return (
      visualResult || rankResult || moduleJsonData?.rankImg?.rankData?.[4]?.val
    );
  }, [moduleJsonData]);

  const secondImg = useMemo(() => {
    const visualResult = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("bgSetting")
      ?.content("rankSecond")?.val?.val;
    const rankResult = enhancedSafeChainFind(moduleJsonData.rankImg)?.rankData(
      "rankSecond",
    )?.val?.val;
    return (
      visualResult || rankResult || moduleJsonData?.rankImg?.rankData?.[5]?.val
    );
  }, [moduleJsonData]);

  const thirdImg = useMemo(() => {
    const visualResult = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("bgSetting")
      ?.content("rankThird")?.val?.val;
    const rankResult = enhancedSafeChainFind(moduleJsonData.rankImg)?.rankData(
      "rankThird",
    )?.val?.val;
    return (
      visualResult || rankResult || moduleJsonData?.rankImg?.rankData?.[6]?.val
    );
  }, [moduleJsonData]);

  const rankImages = useMemo(() => {
    return [firstImg, secondImg, thirdImg]; // 索引0不使用，1-3对应第1、2、3名
  }, [firstImg, secondImg, thirdImg]);

  const bacUrl = (rank: number) => {
    return (
      rankImages?.[rank - 1] || moduleJsonData?.rankImg?.rankData?.[rank + 3]?.val
    );
  };

  const firstUserName = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("firstUserName")?.val?.styleData;
    return result || [];
  }, [moduleJsonData]);

  const secondUserName = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("secondUserName")?.val?.styleData;
    return result || [];
  }, [moduleJsonData]);

  const thirdUserName = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("thirdUserName")?.val?.styleData;
    return result || [];
  }, [moduleJsonData]);

  const userNameStyleLists = useMemo(() => {
    return [firstUserName, secondUserName, thirdUserName];
  }, [firstUserName, secondUserName, thirdUserName]);

  const userNameStyles = (rank: number) => {
    return userNameStyleLists?.[rank - 1] || null;
  };

  const hdFontVal = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "activityValueName",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[3]?.val;
  }, [moduleJsonData]);
  const isSmall = (index: number, item: any) => {
    if (list.length >= 3) {
      return index % 2 == 0;
    }
    if (list.length == 2) {
      return item.activityRank != 1;
    }
    if (list.length == 1) {
      return false;
    }
  };

  useEffect(() => {}, []);
  return (
    <div className={style["Box"]}>
      {isPeoModel &&
        list?.map((item, index) => (
          <div
            className={
              isSmall(index, item) ? style["smallBox"] : style["bigBox"]
            }
            key={index}
            style={{
              background: `url(${processOssImage(bacUrl(Number(item.activityRank)))}) no-repeat top / 100%`,
            }}
          >
            <div className={style["yuanTX"]}>
              <img src={processOssImage(item.userUrl)} alt="找不到图片" />
            </div>
            <div className={style["infoBox"]}>
              <div
                className={style["overflowFont"]}
                style={{ paddingBottom: "10px" }}
              >
                <FontSetBox
                  content={item?.userName?.replace("何小鹏", "***")}
                  styleData={userNameStyles(item.activityRank)}
                />
              </div>
              <div className={style["overflowFont"]}>
                <FontSetBox
                  content={`${hdFontVal}：${item.totalActivityValue}`}
                  styleData={null}
                />
              </div>
            </div>
          </div>
        ))}
      {!isPeoModel &&
        list?.map((item, index) => (
          <div
            className={
              isSmall(index, item) ? style["smallBox"] : style["bigBox"]
            }
            key={index}
            style={{
              background: `url(${processOssImage(bacUrl(Number(item?.activityRank)))}) no-repeat top / 100%`,
            }}
          >
            {item?.teamUrlList?.map(
              (userUrl: string | undefined, i: number) => (
                <div
                  className={style["teamYuanTX"]}
                  key={`${userUrl}${i}`}
                  style={{
                    zIndex: i + 1,
                    transform: `translateX(-50%) translateX(${(i - item.teamUrlList.length / 2) * -10}px)`,
                  }}
                >
                  <img src={processOssImage(userUrl)} alt="找不到图片" />
                </div>
              ),
            )}
            <div className={style["infoBox"]}>
              <div
                className={style["overflowFont"]}
                style={{ paddingBottom: "10px" }}
              >
                <FontSetBox
                  content={item.teamName.replace("何小鹏", "***")}
                  styleData={null}
                />
              </div>
              <div className={style["overflowFont"]}>
                <FontSetBox
                  content={`${hdFontVal}：${item.totalActivityValue}`}
                  styleData={null}
                />
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default App;
